<template>
  <div class="main">
    <div class="login_main">
      <div class="login_left">
        <span class="tip">停车云平台管理系统</span>
        <img src="./images/login.png" />
      </div>
      <div class="login_right">
        <div class="login">
          <p class="txt">登录</p>
          <div class="input-control">
            <input type="text"
                   class="form-control"
                   placeholder="请输入您的用户名"
                   v-model="loginForm.fUserNo">
            <img src="./images/person.png"
                 class="icon" />
          </div>
          <div class="input-control">
            <input type="password"
                   class="form-control"
                   placeholder="请输入您的密码"
                   v-model="loginForm.fUserPwd"
                   @keyup.enter="submit">
            <img src="./images/lock.png"
                 class="icon" />
          </div>

          <div class="input-control"
               v-if="isLoginValidate">
            <input type="text"
                   id="code"
                   class="form-control"
                   placeholder="请输入验证码"
                   v-model="loginForm.code"
                   @keyup.enter="submit">
            <img id="codeUrl"
                 @click="getValidateCode" />
          </div>
          <div class="checkbox">
            <label>
              <input type="checkbox"
                     id="rember"
                     v-model="loginForm.rember"> 记住密码
            </label>
          </div>
          <button class="btn btn-block "
                  type="button"
                  id="login_btn"
                  @click="submit">登录</button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>

import * as api from '@/api/user'
import $ from 'jquery'
export default {
  data () {
    return {
      loginForm: {
        fUserNo: '',
        fUserPwd: '',
        code: '',
        rember: false,
        thirdloginstr: ''
      },
      isLoginValidate: false,
      logining: false
    }
  },
  mounted () {
    document.querySelector('body').setAttribute('style', 'background-color:#101837')
    const that = this
    let clientHeight = this.getRJPageSize.getRJPageSize()[3] - 25
    let height = clientHeight - $('.login_main').height()
    $('.login_main').css({ 'margin': height / 2 + 'px auto' })
    window.onresize = function temp () {
      let clientHeight = that.getRJPageSize.getRJPageSize()[3] - 25
      let height = clientHeight - $('.login_main').height()
      $('.login_main').css({ 'margin': height / 2 + 'px auto' })
    }
  },
  beforeDestroy () {
    document.querySelector('body').removeAttribute('style')
  },
  methods: {
    getValidateCode () {
      api.validateCode().then((res) => {
        $('#codeUrl').attr('src', res.data)
      })
    },
    submit () {
      var strings = this.loginForm.fUserNo
      if (strings.replace(/(^s*)|(s*$)/g, '').length === 0) {
        this.$message({
          type: 'warning',
          message: '用户名不能为空'
        })
        return
      }
      var fUserPwd = this.loginForm.fUserPwd
      if (fUserPwd.replace(/(^s*)|(s*$)/g, '').length === 0) {
        this.$message({
          type: 'warning',
          message: '密码不能为空'
        })
        return
      }
      if (this.isLoginValidate) {
        var code = this.loginForm.code
        if (code.replace(/(^s*)|(s*$)/g, '').length === 0) {
          this.getValidateCode()
          this.$message({
            type: 'warning',
            message: '验证码不能为空'
          })
          return
        }
      }

      $('#login_btn').addClass('disabled')
      $('#login_btn').text('登录中……')
      api.userLogin(this.loginForm).then(res => {
        $('#login_btn').removeClass('disabled')
        $('#login_btn').text('登录')
        this.logining = false
        // 根据返回的code判断是否成功
        let { status, data } = res
        if (status !== 200) {
          this.$message({
            type: 'error',
            message: data
          })
        } else {
          if (data.IsOk) {
            localStorage.setItem('fUserNo', data.Data.fUsrNo)
            localStorage.setItem('fGroupName', data.Data.fGrpName)
            localStorage.setItem('fUsrID', data.Data.fUsrID)
            localStorage.setItem('rember', data.Data.rember)
            localStorage.setItem('panelUrl', data.Data.panelUrl)
            localStorage.setItem('svrPanelUrl', data.Data.svrPanelUrl)
            localStorage.setItem('svrPanelUsrNo', data.Data.svrPanelUsrNo)
            localStorage.setItem('fUsrName', data.Data.fUsrName)
            localStorage.setItem('fIsDefaultPwd', data.Data.fIsDefaultPwd)
            localStorage.setItem('rember', true)
            api.tokenHeaderValue().then(result => {
              if (result.status === 200) {
                this.$router.push({ path: '/' })
              }
            })
          } else {
            if (this.isLoginValidate) {
              this.getValidateCode()
            }
            this.$message({
              type: 'error',
              message: data.Msg
            })
          }
        }
      })
    },
    reset () {
      this.$refs.loginForm.resetFields()
    }
  },
  created () {
    var url = window.location.href
    if (url.includes('thirdloginstr')) {
      this.loginForm.thirdloginstr = url
      api.userThirdLogin(this.loginForm).then(res => {
        $('#login_btn').removeClass('disabled')
        $('#login_btn').text('登录')
        this.logining = false
        // 根据返回的code判断是否成功
        let { status, data } = res
        if (status !== 200) {
          this.$message({
            type: 'error',
            message: data
          })
        } else {
          if (data.IsOk) {
            localStorage.setItem('fUserNo', data.Data.fUsrNo)
            localStorage.setItem('fGroupName', data.Data.fGrpName)
            localStorage.setItem('fUsrID', data.Data.fUsrID)
            localStorage.setItem('rember', data.Data.rember)
            localStorage.setItem('panelUrl', data.Data.panelUrl)
            localStorage.setItem('svrPanelUrl', data.Data.svrPanelUrl)
            localStorage.setItem('svrPanelUsrNo', data.Data.svrPanelUsrNo)
            localStorage.setItem('fUsrName', data.Data.fUsrName)
            localStorage.setItem('fIsDefaultPwd', data.Data.fIsDefaultPwd)
            localStorage.setItem('rember', true)
            api.tokenHeaderValue().then(result => {
              if (result.status === 200) {
                this.$router.push({ path: '/' })
              }
            })
          } else {
            if (this.isLoginValidate) {
              this.getValidateCode()
            }
            this.$message({
              type: 'error',
              message: data.Msg
            })
          }
        }
      })
    }
    var code = this.getQueryString('code')
    var authorization = this.getQueryString('authorization')
    if ((code || '').trim().length > 0 || (authorization || '').trim().length > 0) {
      api.otherLogin({ code: code, authorization: authorization }).then(res => {
        // 根据返回的code判断是否成功
        let { status, data } = res
        if (status !== 200) {
          this.$message({
            type: 'error',
            message: data
          })
        } else {
          if (data.IsOk) {
            localStorage.setItem('fUserNo', data.Data.fUsrNo)
            localStorage.setItem('fGroupName', data.Data.fGrpName)
            localStorage.setItem('fUsrID', data.Data.fUsrID)
            localStorage.setItem('rember', data.Data.rember)
            localStorage.setItem('panelUrl', data.Data.panelUrl)
            localStorage.setItem('svrPanelUrl', data.Data.svrPanelUrl)
            localStorage.setItem('svrPanelUsrNo', data.Data.svrPanelUsrNo)
            localStorage.setItem('fUsrName', data.Data.fUsrName)
            localStorage.setItem('rember', true)
            api.tokenHeaderValue().then(result => {
              if (result.status === 200) {
                // this.$router.push('/')
                window.location.href = '/'
              }
            })
          } else {
            if (this.isLoginValidate) {
              this.getValidateCode()
            }
            this.$message({
              type: 'error',
              message: data.Msg
            })
          }
        }
      })
    }
    api.initConfig().then((res) => {
      let { data } = res
      if (data.IsOk) {
        this.isLoginValidate = data.Data.validate
        if (this.isLoginValidate) {
          this.getValidateCode()
        }
      }
    })
  }
}
</script>

<style scoped>
@import "../../assets/css/zui.css";
body {
  width: 100%;
  height: 100%;
}

.main {
  width: 100%;
  min-width: 1024px;
}

.login_main {
  width: 1000px;
  height: 500px;
  margin: 0px auto;
  overflow: hidden;
  z-index: 1;
  -webkit-transform: scale(1.05);
  -moz-transform: scale(1.05);
  -o-transform: scale(1.05);
  transform: scale(1.05);
  opacity: 1;
  z-index: 20;
  box-shadow: 0px 0px 5px 5px rgba(9, 2, 4, 0.1);
}

.login_left {
  width: 600px;
  float: left;
  height: 500px;
  position: relative;
}

.login_left img {
  width: 600px;
  height: 540px;
}

.login_left .tip {
  position: absolute;
  left: 30px;
  top: 25px;
  color: #a6b5fe;
  font-size: 22px;
  font-weight: 400;
  letter-spacing: 2px;
}

.login_right {
  width: 400px;
  float: right;
  height: 500px;
  background: #ffffff;
  position: relative;
}

.login {
  width: 300px;
  margin: 100px auto;
}

.login p.txt {
  text-align: center;
  font-size: 30px;
  color: #202b51;
  font-weight: 400;
  letter-spacing: 2px;
}
.login .input-control {
  overflow: hidden;
}
.login .input-control .form-control {
  height: 40px;
  border-color: #334877;
  padding-left: 40px;
  font-size: 13px;
}
.login #code {
  padding-left: 10px;
  width: 200px;
  float: left;
}
.login #codeUrl {
  width: 100px;
  border: none;
  height: 40px;
  float: left;
  border: 1px solid #ccc;
}
.form-control:focus {
  border-color: #373c3d;
  outline: 0;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px #7c7676;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px #7c7676;
}

.login .input-control {
  margin-bottom: 20px;
  position: relative;
}

.login .input-control img.icon {
  position: absolute;
  left: 10px;
  top: 10px;
  width: 20px;
  height: 20px;
}

.btn-block {
  background: #334877;
  height: 45px;
  font-size: 20px;
  color: #d7d7d7;
  font-weight: 200;
  outline: none;
}

.btn-block:hover,
.btn-block:focus {
  color: #d7d7d7;
  background: #202b51;
}

.btn-block:focus {
  outline: none;
}

.btn.disabled {
  background-color: #202b51 !important;
  border-color: #bfbfbf !important;
}
.checkbox label {
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/view/login/Login.vue